import { usePath } from "@/contexts/path/path";
import { useAuthState } from "@/contexts/auth/auth.provider";
import React, { useEffect, useState } from "react";
import Icon from "@/components/icon";
import { trackGenericCTAClickEvent } from "@/lib/tracking/trackNavigationEvents";
import styles from "@/containers/project-screen/project.module.scss";
import useFindProject from "./useFindProject";
import { getProjectURL } from "./ProjectCard";
import {
  ShowPhoneButton,
  WhatsAppButton,
} from "@/containers/project-screen/ProjectView";

export function ProjectGeneralControls({
  frozenContext,
  unit,
  onUnitChange,
  compact,
  onWhatsAppClick = () => {},
}) {
  const { currentFrozenIndex: idx, resolving, project } = usePath();
  const { user } = useAuthState();
  const [currentFrozenIndex, setCurrentFrozenIndex] = useState(idx || 0);
  const [{ totalUnits }, frozenUnits, loading] = useFindProject(frozenContext);
  const [disableNextAndPrevious, setDisableNextAndPrevious] = useState(false);
  useEffect(() => {
    if (resolving) return setDisableNextAndPrevious(true);
    const id = setTimeout(() => setDisableNextAndPrevious(false), 100);
    return () => {
      clearTimeout(id);
    };
  }, [resolving]);

  useEffect(() => {
    function ls(e) {
      setCurrentFrozenIndex(e.detail?.index || 0);
    }
    document.addEventListener("updatefrozenindex", ls);

    return () => document.removeEventListener("updatefrozenindex", ls);
  }, []);
  return (
    <div className={`${styles.controlBtns} ${compact && styles.compact}`}>
      <button
        disabled={
          disableNextAndPrevious ||
          loading ||
          resolving ||
          !frozenUnits?.length ||
          !currentFrozenIndex
        }
        data-event-target="previous unit"
        onClick={(e) => {
          // setDisableNextAndPrevious(true);
          trackGenericCTAClickEvent(e);
          let acc = currentFrozenIndex - 1;
          while (frozenUnits[acc]?.native) {
            logger.log("native", { acc });
            acc--;
          }
          if (!frozenUnits[acc]) return;

          setCurrentFrozenIndex(acc);

          onUnitChange({
            unit: {
              ...frozenUnits[acc],
              url: getProjectURL({
                id: project.id,
                title: project.title,
                real_estate_developer: project.real_estate_developer,
                unitId: frozenUnits[acc].id,
                unitCode: frozenUnits[acc].unitCode,
              }),
            },
            currentFrozenIndex: acc,
          });
        }}
        type="button"
      >
        <Icon
          className={styles.rotated}
          width={20}
          height={16}
          name="leftArrow-searches"
        />
        {!compact && "الإعلان السابق"}
      </button>
      {compact && (
        <div className={styles.compactContactBtns}>
          <WhatsAppButton
            unitId={unit.id}
            project={project}
            compact={compact}
            onClick={onWhatsAppClick}
          />
        </div>
      )}
      <button
        disabled={
          disableNextAndPrevious ||
          loading ||
          resolving ||
          !frozenUnits.length ||
          currentFrozenIndex + 1 >= frozenUnits.length
        }
        data-event-target="next listing"
        onClick={(e) => {
          let acc = 1 + currentFrozenIndex;
          while (frozenUnits[acc]?.native) {
            logger.log("native", { acc });
            acc++;
          }
          if (!frozenUnits[acc]) return;
          const unit_ = frozenUnits[acc];
          setCurrentFrozenIndex(acc);
          onUnitChange({
            unit: {
              ...unit_,
              url: getProjectURL({
                id: project.id,
                title: project.title,
                real_estate_developer: project.real_estate_developer,
                unitId: unit_.id,
                unitCode: unit_.unitCode,
              }),
            },
            currentFrozenIndex: acc,
          });
        }}
        type="button"
      >
        {!compact && "الإعلان التالي"}
        <Icon width={20} height={16} name="leftArrow-searches" />
      </button>
    </div>
  );
}
